var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "shortcut-cell-wrapper",
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("avatar", {
        staticClass: "profile-avatar",
        attrs: {
          backgroundColor: _vm.avatarBgColor,
          color: "#000",
          size: "48",
          username: _vm.username
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "name-wrapper" }, [
        _vm.name.length
          ? _c("div", { staticClass: "top-section" }, [
              _c("div", { staticClass: "title-styling" }, [
                _vm._v(_vm._s(_vm.name))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle-styling" }, [
          _vm._v(_vm._s(_vm.email))
        ]),
        _vm._v(" "),
        _vm.shareType.length
          ? _c(
              "div",
              {
                staticClass: "shareType-Styling",
                style: _vm.getStyles(this.shareType)
              },
              [_vm._v("\n      " + _vm._s(_vm.shareType) + "\n    ")]
            )
          : _vm.sharedResources.length
          ? _c("div", { staticClass: "date-resources-wrapper" }, [
              _c(
                "div",
                { staticClass: "resource-cells-wrapper" },
                _vm._l(_vm.sharedResources, function(resources) {
                  return _c("div", { key: resources.id }, [
                    _c(
                      "div",
                      {
                        staticClass: "shareType-Styling",
                        style: _vm.getStyles(resources.resourceType),
                        on: {
                          click: function($event) {
                            return _vm.$emit(
                              "itemClick",
                              resources.resourceType,
                              _vm.parentIndex
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.getSharedResourceTitle(resources)) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _vm.shareDate
                ? _c("div", [_vm._v(_vm._s(_vm.shareDate))])
                : _vm._e()
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showDeleteIcon
        ? _c(
            "div",
            {
              staticClass: "delete-wrapper",
              on: {
                mouseover: function($event) {
                  _vm.hover = true
                },
                mouseleave: function($event) {
                  _vm.hover = false
                }
              }
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: {
                    bottom: "",
                    light: "",
                    color: "#000000",
                    "open-on-hover": "true",
                    "open-on-click": "false",
                    "open-on-focus": "false",
                    "max-width": "150"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-icon",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "fa-regular fa-trash-xmark",
                                    style: _vm.styleButton,
                                    attrs: { size: "24" },
                                    on: {
                                      click: function($event) {
                                        return _vm.$emit("btnClick")
                                      }
                                    }
                                  },
                                  "v-icon",
                                  attrs,
                                  false
                                ),
                                on
                              )
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2680219643
                  )
                },
                [_vm._v(" "), _c("span", [_vm._v("Remove share")])]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }